import {useQuery} from '@apollo/react-hooks';
import gql from 'graphql-tag';
import {CmsCopy} from '../graphql/common.datatypes';

export interface LangDictionaryData {
    allCmsCopy: CmsCopy[]
}

export const GET_CMS_COPY_QUERY = gql`
    query allCmsCopy{
        allCmsCopy {
            id
            key
            body
            is_html
        }
    }
`;

export const allCmsCopy = () => useQuery<LangDictionaryData>(
    GET_CMS_COPY_QUERY,
    {
        variables: {}
    }
);

export default allCmsCopy;